import isInternalUser from "./isInternalUser";

/**
 * Resolves the auth mechanism (host-only, via isInternalUser) and whether a
 * resumable footprint exists. `loginType` is written as an informational tag
 * only — it is never read to decide the mechanism.
 *
 * - internal host -> "sso", always. Footprint = cached MSAL account (SSO
 *   mounts regardless and attempts silent revival, incl. ssoSilent).
 * - external host -> "external" (CIAM), always. Footprint = stored jwtToken.
 *   Have token: resume it. No token: caller should go to PRE_LOGIN.
 *
 * @param {object} [deps]
 * @param {{ getAllAccounts: () => any[] }} [deps.msalInstance]
 * @returns {{ mechanism: "sso" | "external", hasFootprint: boolean }}
 */
const resolveSessionFootprint = ({ msalInstance } = {}) => {
  const mechanism = isInternalUser() ? "sso" : "external";

  if (sessionStorage.getItem("loginType") !== mechanism) {
    sessionStorage.setItem("loginType", mechanism);
  }

  if (mechanism === "sso") {
    const accounts = msalInstance?.getAllAccounts?.() ?? [];
    return { mechanism, hasFootprint: accounts.length > 0 };
  }

  return {
    mechanism,
    hasFootprint: Boolean(sessionStorage.getItem("jwtToken")),
  };
};

export default resolveSessionFootprint;

